import moreInfo from './shared/moreInfo';
import trialInfo from './shared/trialInfo';
import { protocolClassNames } from '../classes'
import { setHiddenFields } from '../protocol/utils/utils';
import { getWidget } from '../shared/utils';

const hideFields = {
  root: ["research_information"]
}

export const ctgResultsUISchema = (configs) => {
  let preview = configs?.preview;

  let returnObj = {
    results: {
      "ui:order": ["participant_flow", "baseline_characteristics", "outcome_measures", "adverse_events", "*"],
      "ui:options": {
        classNames: protocolClassNames
      },
      participant_flow: {
        "ui:options": {
          title: "Participant Flow",
          classNames: {
            objectTitleContainer: "rjs-h1-container",
            objectTitle: "rjs-h1",
            fieldContainer: "rjs-full"
          }
        },
        protocol_enrollment: {
          "ui:options": {
            title: "Protocol Enrollment",
            label: false,
            classNames: {
              fieldContainer: "rjs-full",
              field: "rjs-col-1-3"
            },
          },
        },
        recruitment_details: {
          "ui:options": {
            title: "Recruitment Details",
            label: false,
            charCountEnabled: true,
            maxChars: 500,
            classNames: {
              fieldContainer: "rjs-full",
            },
          },
          "ui:widget": "textarea"
        },
        pre_assignment_details: {
          "ui:options": {
            title: "Pre-assignment Details (Optional)",
            label: false,
            charCountEnabled: true,
            maxChars: 500,
            classNames: {
              fieldContainer: "rjs-full",
            },

          },
          "ui:widget": "textarea"
        },
        type_units_analyzed: {
          "ui:options": {
            title: "Type of Units Assigned",
            label: false,
            charCountEnabledFieldLevel: true,
            maxChars: 40,
            classNames: {
              fieldContainer: "rjs-full",
              field: "rjs-col-1-3"
            },
          },
          "ui:widget": "TypeUnitsAssigned"
        },
        participant_flow_table: {
          "ui:options": {
            label: false,
          },
          "ui:widget": getWidget({ type: "ParticipantFlow", preview })
        }
      },
      baseline_characteristics: {
        "ui:options": {
          title: "Baseline Characteristics",
          classNames: {
            objectTitleContainer: "rjs-h1-container",
            objectTitle: "rjs-h1",
            fieldContainer: "rjs-full"
          }
        },
        baseline_characteristics_table: {
          "ui:options": {
            label: false,
          },
          "ui:widget": getWidget({ type: "BaselineCharacteristics", preview })
        }
      },
      outcome_measures: {
        "ui:options": {
          title: "Outcome Measures",
          customFnProps: [
            {
              tooltip: "Copy all outcome measures from CTG Protocol",
              fnKey: "copy-ctg-protocol-om-to-results",
              fnArgs: {
                // type: "copy-ctg-om",
              }
            },
            {
              tooltip: "Sort by Outcome Measure/End Point Type",
              icon: "fa-light fa-sort",
              fnKey: "sort-result-oms-by-type",
              fnArgs: {
                // type: "copy-ctg-om",
              }
            }],
          classNames: {
            objectTitleContainer: "rjs-h1-container",
            objectTitle: "rjs-h1",
            fieldContainer: "rjs-full"
          }
        },
        outcome_measures_table: {
          "ui:options": {
            label: false,
          },
          "ui:widget": getWidget({ type: "OutcomeMeasures", preview })
        }
      },
      adverse_events: {
        "ui:options": {
          title: "Adverse Events",
          classNames: {
            objectTitleContainer: "rjs-h1-container",
            objectTitle: "rjs-h1",
            fieldContainer: "rjs-full"
          }
        },
        adverse_events_table: {
          "ui:options": {
            label: false,
          },
          "ui:widget": getWidget({ type: "AdverseEvents", preview })
        }
      },
      more_info: moreInfo('ctg', preview),
      trial_info: trialInfo('ctg', preview),
      ...setHiddenFields(hideFields.root)
    }
  }

  // if (preview === true) {
  //   getPreviewStyles(returnObj);
  // }

  return returnObj;
}